import React from "react";
import type { Root } from "react-dom/client";

import DashboardLoadingShell from "../Components/Dashboard/Skeleton/DashboardLoadingShell";
import SettingsLoadingShell from "../Components/Settings/Skeleton/SettingsLoadingShell";
import OnboardingLoadingShell from "../Components/Onboarding/Skelton/OnboardingLoadingShell";
import {
  shouldShowDashboardBootShell,
  shouldShowOnboardingBootShell,
} from "../utils/onboardingBootHint";

/** Minimal route shell — no Redux, Polaris CSS, or App chunk required. */
function getBootShellElement(): React.ReactElement {
  const pathname =
    typeof window !== "undefined"
      ? window.location.pathname.replace(/^\/etsy/, "") || "/"
      : "/";

  // First-time users open at `/` then redirect to onboarding — show that skeleton, not dashboard.
  if (shouldShowOnboardingBootShell(pathname)) {
    return <OnboardingLoadingShell />;
  }

  if (shouldShowDashboardBootShell(pathname)) {
    return <DashboardLoadingShell />;
  }

  if (pathname === "/settings" || pathname.startsWith("/settings/")) {
    return <SettingsLoadingShell />;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#ffffff",
      }}
    />
  );
}

/** Paint route-matched skeleton immediately for FCP (before the main app bundle parses). */
export function renderBootShell(root: Root): void {
  root.render(getBootShellElement());
}
